<template>
  <b-navbar toggleable="md" type="light" variant="light" class="mobile-navbar">
    <div class="d-flex justify-content-between align-items-center w-100">
      <b-navbar-brand>
        <div class="d-flex align-items-center">
          <img
            src="@/assets/images/logo_icon.png"
            alt="Pitaya"
            class="mobile-logo"
          />
        </div>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" class="border-0"></b-navbar-toggle>
    </div>

    <b-collapse id="nav-collapse" is-nav class="no-transition">
      <b-navbar-nav class="mt-2">
        <b-nav-item
          v-for="link in standardPageLinks"
          :key="link.name"
          :to="link.to"
        >
          <i
            :class="'fi-' + link.icon + ' nav-icon'"
            style="margin-right: 8px"
          ></i>
          {{ $t(link.name) }}
        </b-nav-item>
        <b-nav-item @click="handleLogout">
          <i class="fi-eject nav-icon" style="margin-right: 8px"></i>
          {{ $t("sidenav.logout") }}
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      standardPageLinks: [
        {
          name: "sidenav.dashboard",
          to: "/en/dashboard",
          icon: "graph-bar",
        },
        {
          name: "sidenav.reservations",
          to: "/en/reservations",
          icon: "calendar",
        },
        {
          name: "sidenav.contacts",
          to: "/en/contacts",
          icon: "torsos",
        },
        {
          name: "sidenav.tabs",
          to: "/en/tabs",
          icon: "credit-card",
        },
        {
          name: "sidenav.analytics",
          to: "/en/analytics",
          icon: "graph-pie",
        },
        {
          name: "sidenav.settings",
          to: "/en/settings",
          icon: "widget",
        },
      ],
    };
  },
  methods: {
    handleLogout() {
      this.$store.dispatch("logout").then(() => {
        const token = this.$cookie.get("laravel_session");
        this.$cookie.delete("laravel_session");
        this.$cookie.delete("fe_session");
      });
    },
  },
};
</script>

<style lang="scss">
.mobile-navbar {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 1rem;
  flex-direction: column;

  .mobile-logo {
    height: 30px;
    width: auto;
    margin-right: 10px;
  }

  .brand-name {
    font-size: 1.2rem;
    font-weight: 500;
    color: #333;
  }

  .navbar-toggler {
    padding: 0.25rem 0.5rem;

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }

  .nav-icon {
    font-size: 1.2rem;
    color: #333;
  }

  .navbar-nav {
    .nav-item {
      padding: 0.5rem 1rem;

      &:hover {
        background-color: rgba(0, 123, 255, 0.1);
      }
    }
  }

  .no-transition {
    transition: none !important;
  }
}

@media screen and (max-width: 767px) {
  .mobile-navbar {
    display: flex;
  }
}
</style>
